import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { getImageSrc } from '../../../../shared/imgsrc';

@Component({
  imports: [CommonModule],
  selector: 'automata-preview-image-container',
  templateUrl: './preview-image-container.component.html',
  styleUrls: ['./preview-image-container.component.scss'],
})
export class PreviewImageContainerComponent {
  protected readonly imageUrl = input<string>();

  protected readonly placeholderImgSrc = getImageSrc('images/email-preview-placeholder.png');
}
